import React from 'react';
import { Rate } from 'antd';
const App = () => <Rate disabled defaultValue={2} />;
export default App;